module.exports = __webpack_public_path__ + "static/media/Pin-Dark-Ocorrencia.ad7bad17.svg";